export enum BusinessRuleErrorEnum {
  ADDRESS_MISSING = "address_missing",
  BASKET_MIN_VALUE = "basket_min_value",
  CARD_ONLINE_DECLINED = "card_online_declined",
  DISCOUNT_NOT_AVAILABLE_FOR_GUEST = "discount_not_available_for_guest",
  DISCOUNT_NOT_FOUND = "discount_not_found",
  CURBSIDE_SERVICE_UNAVAILABLE = "curbside_service_unavailable",
  DELIVERY_SERVICE_UNAVAILABLE = "delivery_service_unavailable",
  GIFT_CARD_COULD_NOT_BE_APPLIED = "gift_card_could_not_be_applied",
  ITEM_NOT_FOUND = "item_not_found",
  ITEM_OUT_OF_STOCK = "item_out_of_stock",
  LOYALTY_FREE_ITEM_NOT_FOUND = "loyalty_free_item_not_found",
  LOYALTY_PROGRAM_NO_LONGER_AVAILABLE = "loyalty_program_no_longer_available",
  MAX_ORDER_CAPACITY = "maximum_order_capacity",
  OUTLET_CLOSED_FOR_SERVICE = "outlet_closed_for_service",
  SALES_CHANNEL_NOT_ENABLED = "sales_channel_not_enabled",
  STORE_NOT_ACCEPTING_ORDERS = "store_not_accepting_orders",
  VOUCHER_RULES_VIOLATED = "voucher_rules_violated",
  DISCOUNT_ELIGIBLE_ITEMS_MISSING = "discount_eligible_items_missing",
  CUSTOMER_ADDRESS_MUST_BE_PROVIDED = "customer_address_must_be_provided",
}
